/** Universal Billing settings tabs (Account settings → Billing). */

export const BILLING_TABS = Object.freeze([
  { id: 'payment-method', label: 'Payment Method', shortLabel: 'Pay' },
  { id: 'per-demand-fee', label: 'Per-demand fee', shortLabel: 'Fee' },
  { id: 'integrations', label: 'Integrations', shortLabel: 'Apps' },
  { id: 'seats', label: 'Seats', shortLabel: 'Seats' },
  { id: 'evidence-locker', label: 'Evidence Locker', shortLabel: 'Locker' },
  { id: 'invoices', label: 'Invoices', shortLabel: 'Invoices' },
]);

export function normalizeBillingTab(raw) {
  const id = String(raw || '').trim().toLowerCase();
  return BILLING_TABS.some((tab) => tab.id === id) ? id : BILLING_TABS[0].id;
}
